import { MuiIconNames } from '@features/cms/typings/material-icon-font'

import { interactionCardConfigSchemaProperties } from './interactionCard'

export const audioCarouselConfigSchema = {
  type: 'object',
  properties: {
    quickTipMaterialIcon: { type: 'string', enum: MuiIconNames },
    ...interactionCardConfigSchemaProperties
  }
}
